import React from "react";

class RechargeDeviceBanner extends React.Component {
    render() {
        return (
          <section className="header_section header_section_active">
            {/* <div className="bg-overlay" / >*/}
            <div className="container">
              <div className="row">

              <div className="col-lg-6">
                <div className="desktop-header">
                  <h4 className="mb-3 SansSerif bold600">MightyWifi</h4>
                  <h1 className="sub no-margin bold600 mb-3">The Best Choice<br/>To Stay Connected<br/><span className="s-font">Anywhere</span></h1>
                  <div className="col-md-12" style={{ clear: "both", height: "10px" }} />
                  <div className="row">
                    <div className="col-md-7">
                      <div className="row">
                        {/*<div className="col-md-4">
                        <div className="icon-box device-img white"></div>
                        </div>*/}
                        <div className="col-md-4">
                        <div className="icon-box device-img black"></div>
                        </div>
                        {/*<div className="col-md-4">
                        <div className="icon-box device-img blue"></div>
                        </div>*/}
                        <div className="col-md-4">
                        <div className="icon-box device-img v3"></div>
                        </div>
                        <div className="col-md-12" style={{ clear: "both", height: "20px" }} />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-lg-6"></div>


              {/*
              <div className="mobile-header">
                <h2 className="SansSerif bold600 m-title-positon">
                  <span className="line-break m-header-mtitle Serif">Coming Soon</span>
                  <span className="line-break m-header-stitle">2ND generation of global wifi hotspot</span>
                  MightyWifi Cloud
                </h2>
              </div>
              */}

              </div>
            </div>
            <div id="TopSection"></div>
          </section>
        );
    }
}

export default RechargeDeviceBanner;



// WEBPACK FOOTER //
// ./src/reusable/ActiveDeviceBanner.js